module.exports = __webpack_public_path__ + "img/73.62950a1c.svg";